import { createContext, useContext, useState } from "react";
const MessageContext = createContext(undefined);
export const MessageProvider = ({ children }) => {
    const [currentMessage, setCurrentMessage] = useState(null);
    const [isVisible, setIsVisible] = useState(false);

    const showMessage = (message) => {
        setCurrentMessage({
            text: message.text,
            type: message.type,
            title: message.title,
        });
        setIsVisible(true);
    };

    const hideMessage = () => {
        setIsVisible(false);
    };

    return (
        <MessageContext.Provider
            value={{ showMessage, hideMessage, currentMessage, isVisible }}
        >
            {children}
        </MessageContext.Provider>
    );
};

export const useMessage = () => {
    const context = useContext(MessageContext);
    if (context === undefined) {
        throw new Error("useMessage must be used within a MessageProvider");
    }
    return context;
};
